// Suara notifikasi pendek via Web Audio API (tanpa file audio eksternal)
let ctx = null;
const MUTE_KEY = "siap_notif_sound_off";
export const soundOff = () => localStorage.getItem(MUTE_KEY) === "1";
export const setSoundOff = (v) => (v ? localStorage.setItem(MUTE_KEY, "1") : localStorage.removeItem(MUTE_KEY));

export const playNotifSound = () => {
  if (soundOff() || document.visibilityState !== "visible") return false;
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return false;
    ctx = ctx || new AC();
    if (ctx.state === "suspended") ctx.resume();
    const t0 = ctx.currentTime;
    [[880, 0], [1175, 0.12]].forEach(([freq, dt]) => {
      const o = ctx.createOscillator(); const g = ctx.createGain();
      o.type = "sine"; o.frequency.value = freq;
      g.gain.setValueAtTime(0.0001, t0 + dt); g.gain.exponentialRampToValueAtTime(0.25, t0 + dt + 0.02); g.gain.exponentialRampToValueAtTime(0.0001, t0 + dt + 0.22);
      o.connect(g); g.connect(ctx.destination); o.start(t0 + dt); o.stop(t0 + dt + 0.25);
    });
    return true;
  } catch { return false; }
};
